/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiSummaryCardReferenceMeta
 */
export interface AiSummaryCardReferenceMeta {
    /**
     * 
     * @type {string}
     * @memberof AiSummaryCardReferenceMeta
     */
    outcome: AiSummaryCardReferenceMetaOutcomeEnum;
    /**
     * 
     * @type {string}
     * @memberof AiSummaryCardReferenceMeta
     */
    title_label: string;
    /**
     * 
     * @type {string}
     * @memberof AiSummaryCardReferenceMeta
     */
    category_label: string;
    /**
     * 
     * @type {string}
     * @memberof AiSummaryCardReferenceMeta
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof AiSummaryCardReferenceMeta
     */
    secondary_body?: string;
}


/**
 * @export
 */
export const AiSummaryCardReferenceMetaOutcomeEnum = {
    Yes: 'YES',
    No: 'NO',
    Unresolved: 'UNRESOLVED'
} as const;
export type AiSummaryCardReferenceMetaOutcomeEnum = typeof AiSummaryCardReferenceMetaOutcomeEnum[keyof typeof AiSummaryCardReferenceMetaOutcomeEnum];


/**
 * Check if a given object implements the AiSummaryCardReferenceMeta interface.
 */
export function instanceOfAiSummaryCardReferenceMeta(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "outcome" in value;
    isInstance = isInstance && "title_label" in value;
    isInstance = isInstance && "category_label" in value;
    isInstance = isInstance && "body" in value;

    return isInstance;
}

export function AiSummaryCardReferenceMetaFromJSON(json: any): AiSummaryCardReferenceMeta {
    return AiSummaryCardReferenceMetaFromJSONTyped(json, false);
}

export function AiSummaryCardReferenceMetaFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiSummaryCardReferenceMeta {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'outcome': json['outcome'],
        'title_label': json['title_label'],
        'category_label': json['category_label'],
        'body': json['body'],
        'secondary_body': !exists(json, 'secondary_body') ? undefined : json['secondary_body'],
    };
}

export function AiSummaryCardReferenceMetaToJSON(value?: AiSummaryCardReferenceMeta | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'outcome': value.outcome,
        'title_label': value.title_label,
        'category_label': value.category_label,
        'body': value.body,
        'secondary_body': value.secondary_body,
    };
}

